import * as Yup from 'yup';

import {
  ARTICLE_WRITER_CATEGORY,
  DESCRIPTION_CATEGORIES,
  EMAIL_WRITER_CATEGORY,
  GRAMMAR_CHECKER_CATEGORY,
  IDEA_GENERATOR_CATEGORY,
  INSTAGRAM_CAPTION_CATEGORY,
  INSTAGRAM_HASHTAG_CATEGORY,
  KEYWORDS_CATEGORIES,
  MARKETING_SLOGAN_CATEGORY,
  META_DATA_MAKER_CATEGORY,
  PAGE_OUTLINE_CATEGORY,
  PRODUCT_CATEGORIES,
  REPHRASER_CATEGORY,
  SOCIAL_MEDIA_BIO_CATEGORY,
  STORY_GENERATOR_CATEGORY,
  SUMMARIZER_CATEGORY,
  TITLE_GENERATOR_CATEGORY,
  TRANSLATOR_CATEGORY,
  ESSAY_WRITER_CATEGORY,
  BLOG_IDEA_GENERATOR_CATEGORY,
  BOOK_IDEA_GENERATOR_CATEGORY,
  BUSINESS_IDEA_GENERATOR_CATEGORY,
  CONTENT_IDEA_GENERATOR_CATEGORY,
  DRAWING_IDEA_GENERATOR_CATEGORY,
  GIFT_IDEA_GENERATOR_CATEGORY,
  PAINTING_IDEA_GENERATOR_CATEGORY,
  SIDE_HUSTLE_IDEA_GENERATOR_CATEGORY,
  STARTUP_IDEA_GENERATOR_CATEGORY,
  STORY_IDEA_GENERATOR_CATEGORY,
  CREATE_CATEGORY,
  DOCUMENT_TITLE_GENERATOR_CATEGORY,
  LANDING_PAGE_TITLE_GENERATOR_CATEGORY,
  SOCIAL_MEDIA_POST_TITLE_GENERATOR_CATEGORY,
  STORY_TITLE_GENERATOR_CATEGORY,
  VIDEO_TITLE_GENERATOR_CATEGORY,
  BLOG_TITLE_GENERATOR_CATEGORY,
  BOOK_TITLE_GENERATOR_CATEGORY,
  CONTENT_TITLE_GENERATOR_CATEGORY,
  PROMPT_GENERATOR_CATEGORY,
  TEXT_PROMPT_GENERATOR_CATEGORY,
  IMAGE_PROMPT_GENERATOR_CATEGORY,
  VIDEO_PROMPT_GENERATOR_CATEGORY,
  CODE_PROMPT_GENERATOR_CATEGORY,
  PARAGRAPH_GENERATOR_CATEGORY,
  INTRODUCTION_PARAGRAPH_GENERATOR_CATEGORY,
  BODY_PARAGRAPH_GENERATOR_CATEGORY,
  CONCLUSION_PARAGRAPH_GENERATOR_CATEGORY,
  VIDEO_SCRIPT_GENERATOR_CATEGORY,
  KEYWORD_GENERATOR_CATEGORY,
  EXPAND_TEXT_CATEGORY,
  SHORTEN_TEXT_CATEGORY,
} from '../../constants';

export const getValidationSchema = (selectedCategory: number) => {
  const validationSchema = Yup.object().shape({
    product: PRODUCT_CATEGORIES.includes(selectedCategory)
      ? Yup.string().required('This field is Required')
      : Yup.string(),
    tellUsAboutYourself:
      SOCIAL_MEDIA_BIO_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    textToParaphrase:
      REPHRASER_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    wordToStart:
      INSTAGRAM_HASHTAG_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    numberOfResults:
      INSTAGRAM_HASHTAG_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    description: DESCRIPTION_CATEGORIES.includes(selectedCategory)
      ? Yup.string().required('This field is Required')
      : Yup.string(),
    purpose:
      EMAIL_WRITER_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    describeYourImage:
      INSTAGRAM_CAPTION_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    keywords: KEYWORDS_CATEGORIES.includes(selectedCategory)
      ? Yup.string().required('This field is Required')
      : Yup.string(),
    textToBeSummarised:
      SUMMARIZER_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    ideaGeneratorTopic:
      IDEA_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    blogIdeaGeneratorTopic:
      BLOG_IDEA_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    bookIdeaGeneratorTopic:
      BOOK_IDEA_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    businessIdeaGeneratorTopic:
      BUSINESS_IDEA_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    contentIdeaGeneratorTopic:
      CONTENT_IDEA_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    drawingIdeaGeneratorTopic:
      DRAWING_IDEA_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    giftIdeaGeneratorTopic:
      GIFT_IDEA_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    paintingIdeaGeneratorTopic:
      PAINTING_IDEA_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    sideHustleIdeaGeneratorTopic:
      SIDE_HUSTLE_IDEA_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    startupIdeaGeneratorTopic:
      STARTUP_IDEA_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    storyIdeaGeneratorTopic:
      STORY_IDEA_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    articleWriterTopic:
      ARTICLE_WRITER_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    describeStory:
      STORY_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    sloganWords:
      MARKETING_SLOGAN_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    textToGrammarCheck:
      GRAMMAR_CHECKER_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    titleGeneratorTopic:
      TITLE_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    blogTitleGeneratorTopic:
      BLOG_TITLE_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    bookTitleGeneratorTopic:
      BOOK_TITLE_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    contentTitleGeneratorTopic:
      CONTENT_TITLE_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    documentTitleGeneratorTopic:
      DOCUMENT_TITLE_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    landingPageTitleGeneratorTopic:
      LANDING_PAGE_TITLE_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    socialMediaPostTitleGeneratorTopic:
      SOCIAL_MEDIA_POST_TITLE_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    storyTitleGeneratorTopic:
      STORY_TITLE_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    videoTitleGeneratorTopic:
      VIDEO_TITLE_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    videoScriptGeneratorTopic:
      VIDEO_SCRIPT_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    describeOutline:
      PAGE_OUTLINE_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    describeTopic:
      META_DATA_MAKER_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    inputValue:
      TRANSLATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    essayInput:
      ESSAY_WRITER_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    createInput:
      CREATE_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    createDetails:
      CREATE_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    promptGeneratorTopic:
      PROMPT_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    textPromptGeneratorTopic:
      TEXT_PROMPT_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    imagePromptGeneratorTopic:
      IMAGE_PROMPT_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    videoPromptGeneratorTopic:
      VIDEO_PROMPT_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    codePromptGeneratorTopic:
      CODE_PROMPT_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    paragraphGeneratorTopic:
      PARAGRAPH_GENERATOR_CATEGORY === selectedCategory ||
      INTRODUCTION_PARAGRAPH_GENERATOR_CATEGORY === selectedCategory ||
      BODY_PARAGRAPH_GENERATOR_CATEGORY === selectedCategory ||
      CONCLUSION_PARAGRAPH_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    keywordsGeneratorTopic:
      KEYWORD_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    textToExpand:
      EXPAND_TEXT_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    textToShorten:
      SHORTEN_TEXT_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
  });
  return validationSchema;
};
